import { toDate } from "date-fns-tz";
import { addMinutes } from "date-fns/fp";

export const addLocalTimeZoneOffset = (date: Date | string | number, referenceDate: Date = new Date()) =>
  addMinutes(referenceDate.getTimezoneOffset(), toDate(date, { timeZone: "UTC" }));
